$(() =>
{
	// collapse alert banner on user click
	$(".standard-alert-banner").on("click", (event) =>
	{
		const alertBanner = $(".standard-alert-banner");
		alertBanner.css("min-height", "0");
		alertBanner.css("max-height", "0");
	})
})